import { IElementBaseModel } from '../../../Interface/base/element-base-model.interface';
import { ICommonProps } from '../base/base.interface';
import { IFrame, MODES } from '../frame.interface';

export interface IBatchUpdateFrameProperty {
    batchUpdateHeight(props: IMultiValueProps): void;
    batchUpdateWidth(props: IMultiValueProps): void;
    batchUpdateLeft(value: number[], updateModelArr: IElementBaseModel[], isOnSlide?: boolean): void;
    batchUpdateTop(value: number[], updateModelArr: IElementBaseModel[], isOnSlide?: boolean): void;
    batchUpdateFrame(props: IMultiFrameProps): void;
    batchUpdateFrameOnSlide(props: IMultiFrameProps): void;
    /** 旋转至指定角度 */
    batchUpdateRotateToAngle(
        value: number | number[], updateModelArr: IElementBaseModel[],
        isOnSlide?: boolean,
    ): void;
    /** 在现有旋转基础上，再旋转 */
    batchUpdateRotateWithAngle(
        value: number | number[], updateModelArr: IElementBaseModel[],
        isOnSlide?: boolean,
    ): void;
}

export interface IMultiValueProps extends ICommonProps {
    value: number[];
    updateModelArr: IElementBaseModel[];
}

export interface IMultiFrameProps {
    frame: Partial<IFrame>[];
    updateModelArr: IElementBaseModel[];
    /**
     * 是否要支持文本框根据文字调整形状
     */
    applyShapeAutoFit?: boolean;
    /**
    * 元素缩放点的位置，可能通过手动缩放元素进行更新
    */
    mode?: MODES;
}

export enum ERectProperty {
    WIDTH = 'width',
    HEIGHT = 'height',
    LEFT = 'left',
    TOP = 'top',
    ROTATE = 'rotate',
}
